if (!customElements.get('featured-collections-element')) {
  class FeaturedCollectionsElement extends HTMLElement {
    connectedCallback() {
      // Small delay to ensure DOM is ready
      setTimeout(() => {
        this.toggles = this.querySelectorAll('.collection-toggle')
        this.collections = this.querySelectorAll('.collection-products')
        this.btns = this.querySelectorAll('.collection-btns')
        this.init()
      }, 0)
    }

    init() {
      this.toggles.forEach(toggle => {
        // Use arrow function to preserve 'this' context
        toggle.onclick = e => this.handleToggle(e)
      })
    }

    handleToggle(e) {
      const button = e.currentTarget
      const collectionId = button.dataset.collectionId

      // Update active toggle - scope to this element instance
      this.toggles.forEach(toggle => {
        toggle.classList.remove('active', 'border-current')
        toggle.classList.add('border-transparent')
      })
      button.classList.add('active', 'border-current')
      button.classList.remove('border-transparent')

      // Show corresponding collection - scope to this element instance
      this.collections.forEach(collection => {
        if (collection.dataset.collectionContent === collectionId) {
          collection.classList.remove('hidden')
        } else {
          collection.classList.add('hidden')
        }
      })

      this.btns.forEach(collection => {
        if (collection.dataset.collectionContent === collectionId) {
          collection.classList.remove('hidden')
        } else {
          collection.classList.add('hidden')
        }
      })
    }
  }

  customElements.define(
    'featured-collections-element',
    FeaturedCollectionsElement
  )
}
